import React, { useState } from "react";
import { Box, Tabs, Tab, Typography, Paper } from "@mui/material";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PeopleIcon from "@mui/icons-material/People";
import VisualPipelineKanban from "./VisualPipelineKanban";
import SchedulingAvailability from "./SchedulingAvailability";
import AllCandidatesTab from "./AllCandidatesTab";
import "./InterviewRedesign.css";

const InterviewTrack = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box sx={{ p: 2, maxWidth: "100%", height: "calc(100vh - 80px)", boxSizing: "border-box", overflow: "hidden", display: "flex", flexDirection: "column" }}>
      <Paper elevation={0} sx={{ p: 2, mb: 2, border: "1px solid #E2E8F0", borderRadius: 2, flexShrink: 0 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <Box>
            <Typography variant="h5" fontWeight={700} color="text.primary">
              Pipeline &amp; Interviews
            </Typography>
            <Typography variant="body2" color="text.secondary" mt={0.5}>
              Manage candidate pipeline, coordinate schedules, and collect structured feedback.
            </Typography>
          </Box>
        </Box>
      </Paper>

      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2, flexShrink: 0, maxWidth: "100%" }}>
        <Tabs
          value={activeTab}
          onChange={(_, v) => setActiveTab(v)}
          sx={{ "& .MuiTab-root": { textTransform: "none", fontWeight: 500 } }}
        >
          <Tab icon={<AccountTreeIcon fontSize="small" />} iconPosition="start" label="Visual Pipeline Kanban" />
          <Tab icon={<CalendarMonthIcon fontSize="small" />} iconPosition="start" label="Scheduling &amp; Availability" />
          <Tab icon={<PeopleIcon fontSize="small" />} iconPosition="start" label="All Candidates" />
        </Tabs>
      </Box>

      <Box sx={{ flexGrow: 1, overflow: activeTab === 0 ? "hidden" : "auto", display: "flex", flexDirection: "column", minHeight: 0, minWidth: 0, maxWidth: "100%" }}>
        {activeTab === 0 && <VisualPipelineKanban />}
        {activeTab === 1 && <SchedulingAvailability />}
        {activeTab === 2 && <AllCandidatesTab />}
      </Box>
    </Box>
  );
};

export default InterviewTrack;
